export const SET_ALL_QUIZZES = "SET_ALL_QUIZZES";
export const SELECT_QUIZZ = "SELECT_QUIZZ";
export const SET_ANSWERS = "SET_ANSWERS";
export const SET_INCOMPLETED_QUIZZES = "SET_INCOMPLETED_QUIZZES";
export const SET_COMPLETED_QUIZZES = "SET_COMPLETED_QUIZZES";
export const RESET_QUIZ_DATA = "RESET_QUIZ_DATA";
export const DELETE_QUIZ = "DELETE_QUIZ";
export const SET_FORWARDED_QUIZZES = "SET_FORWARDED_QUIZZES";
export const SET_REPORT_ID_QUIZZ = "SET_REPORT_ID_QUIZZ";
export const SET_RECOMMENDED_QUIZZES = "SET_RECOMMENDED_QUIZZES";
export const SET_PENDING_RECOMMENDED_QUIZZES = "SET_PENDING_RECOMMENDED_QUIZZES";
export const SET_IDENTIFIER = "SET_IDENTIFIER";
export const SET_THREAT_QUIZZES = "SET_THREAT_QUIZZES";
export const SET_PENDING_THREAT_QUIZZES = "SET_PENDING_THREAT_QUIZZES";
export const SET_QUIZZES_BY_CATEGORIE= "SET_QUIZZES_BY_CATEGORIE";
export const SET_CATEGORIES= "SET_CATEGORYS";
export const SET_CATEGORIES_ADD_QUIZZES= "SET_CATEGORIES_ADD_QUIZZES";
